export default __webpack_public_path__ + "static/media/new-logo.8bcf8f10.svg";